'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Snapshot = function () {
  function Snapshot(title, options, fn) {
    (0, _classCallCheck3.default)(this, Snapshot);

    if (typeof title !== 'string') {
      throw new Error('`title` should be a "string", but "' + (typeof title === 'undefined' ? 'undefined' : (0, _typeof3.default)(title)) + '" was given');
    }

    if (typeof options === 'function' && typeof fn === 'undefined') {
      fn = options;
      options = undefined;
    }

    if ((typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) !== 'object' && typeof options !== 'undefined') {
      throw new Error('`options` should be an "object", but "' + (typeof options === 'undefined' ? 'undefined' : (0, _typeof3.default)(options)) + '" was given');
    }

    this.title = title;
    this.fn = fn;
    this.options = options || {};
  }

  (0, _createClass3.default)(Snapshot, [{
    key: 'fullTitle',
    value: function fullTitle() {
      if (this.parent) {
        var parentTitle = this.parent.fullTitle();
        if (parentTitle) {
          return parentTitle + ': ' + this.title;
        }
      }

      return this.title;
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      if (this.parent) {
        return (0, _extends3.default)({}, this.parent.getOptions(), this.options);
      }

      return this.options;
    }
  }, {
    key: 'getDefinition',
    value: function getDefinition() {
      if (!this.fn) {
        return;
      }

      return {
        name: this.fullTitle(),
        options: this.getOptions()
      };
    }
  }, {
    key: 'getMarkup',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fn();

              case 2:
                return _context.abrupt('return', _context.sent);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMarkup() {
        return _ref.apply(this, arguments);
      }

      return getMarkup;
    }()
  }]);
  return Snapshot;
}();

exports.default = Snapshot;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@percy/react-percy-test-framework/lib/Snapshot.js
// module id = 482
// module chunks = 1